/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 관리자가 내려준 양식(품목ID·신규단가·취급)에 값을 채워 올리면 로그인한 공급사의 단가로 반영된다. 이미 있는 품목은 덮어쓰고, 신규단가가 빈 행은 건드리지 않는다. 오류 행이 있어도 나머지는 반영되며 오류 목록을 함께 돌려준다.
 * @summary 내 단가 엑셀 일괄 등록
 */
export const itemsV2ControllerBulkUploadSupplierPricesBody = zod
  .object({
    file: zod.instanceof(File).optional().describe("단가 엑셀(.xlsx)"),
  })
  .strict();

export const itemsV2ControllerBulkUploadSupplierPricesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        supplierName: zod.string().describe("공급사명"),
        totalRows: zod.number().describe("파일의 데이터 행 수"),
        createdCount: zod.number().describe("새로 등록된 단가 수"),
        updatedCount: zod.number().describe("기존 단가를 덮어쓴 수"),
        skippedCount: zod
          .number()
          .describe(
            "신규단가가 비어 있어 손대지 않은 행 수(취급하지 않는 품목)",
          ),
        errorCount: zod.number().describe("오류로 빠진 행 수"),
        errors: zod
          .array(
            zod
              .object({
                row: zod
                  .number()
                  .describe(
                    "엑셀 행 번호(헤더가 1행). 0 이면 행을 특정할 수 없는 오류다.",
                  ),
                itemId: zod.object({}).nullable().describe("품목ID"),
                reason: zod.string().describe("사유"),
              })
              .strict(),
          )
          .describe("오류 목록(최대 100건)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 
      정부 조달 데이터(items_v2_base) 기반 품목 검색. 상품명, cat1, cat2 필드에서 검색.

      **일반 사용자**: referencePrice, lowestPrice 반환
      **공급사 사용자**: supplierId 파라미터 제공 시 supplierPrice (공급사별 단가) 추가 반환
    
 * @summary 품목 자동완성 검색 (items-v2, 한글 유사 검색 .ilike, 최소 2자)
 */
export const itemsV2ControllerAutocompleteQueryQMin = 2;
export const itemsV2ControllerAutocompleteQueryQMax = 100;

export const itemsV2ControllerAutocompleteQueryLimitDefault = 10;
export const itemsV2ControllerAutocompleteQueryLimitMax = 50;

export const itemsV2ControllerAutocompleteQueryOffsetDefault = 0;
export const itemsV2ControllerAutocompleteQueryOffsetMin = 0;

export const itemsV2ControllerAutocompleteQueryParams = zod
  .object({
    q: zod.coerce
      .string()
      .min(itemsV2ControllerAutocompleteQueryQMin)
      .max(itemsV2ControllerAutocompleteQueryQMax)
      .describe("검색 키워드 (최소 2자)"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(itemsV2ControllerAutocompleteQueryLimitMax)
      .default(itemsV2ControllerAutocompleteQueryLimitDefault)
      .describe("결과 개수 (기본값: 10, 최대: 50)"),
    offset: zod.coerce
      .number()
      .min(itemsV2ControllerAutocompleteQueryOffsetMin)
      .default(itemsV2ControllerAutocompleteQueryOffsetDefault)
      .describe(
        "결과 오프셋 (기본: 0). limit 상한(50) 너머로 페이징할 때 사용 — offset=50 이면 51번째부터 반환한다. 응답은 그대로 배열이며, 반환 건수가 limit 과 같으면 다음 페이지가 있을 수 있다.",
      ),
    supplierId: zod.coerce
      .string()
      .optional()
      .describe("공급사 ID (선택사항 - 공급사별 단가 조회 시 필요)"),
    categoryIds: zod
      .array(zod.coerce.string())
      .optional()
      .describe(
        "카테고리 ID 필터 (선택사항). 지정 시 해당 카테고리 품목만 검색한다. 쉼표 구분 또는 반복 쿼리 파라미터(categoryIds=a&categoryIds=b) 모두 허용.",
      ),
    sortBy: zod
      .enum(["name", "supplierCount", "autoQuoteSupplierCount"])
      .optional()
      .describe("정렬 기준 (기본값: name)"),
    sortOrder: zod
      .enum(["ASC", "DESC"])
      .optional()
      .describe("정렬 순서 (기본값: ASC)"),
    catalogEpoch: zod
      .enum(["legacy", "v2"])
      .optional()
      .describe(
        "카탈로그 epoch 필터. legacy=2026-05-19 이전 등록 품목, v2=이후 등록 품목. 미지정 시 전체.",
      ),
  })
  .strict();

export const itemsV2ControllerAutocompleteResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            casNo: zod
              .string()
              .nullish()
              .describe(
                "CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)",
              ),
            keNo: zod
              .string()
              .nullish()
              .describe(
                "국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null",
              ),
            unNo: zod
              .string()
              .nullish()
              .describe("UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null"),
            enNo: zod.string().nullish().describe("EC 번호 (EU EINECS/ELINCS)"),
            chemNameKor: zod
              .string()
              .nullish()
              .describe("KOSHA 기준 국문 표준 물질명"),
            id: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
            name: zod.string().describe("상품명"),
            categoryId: zod
              .string()
              .nullable()
              .describe(
                "카테고리 ID (items_v2_categories.id - UUID, FK to normalized category table)",
              ),
            categoryPath: zod.string().describe("카테고리 경로 (표시용)"),
            price: zod.number().describe("기준 가격 (정가)"),
            lowestPrice: zod.number().nullable().describe("최저가 거래 단가"),
            lowestPriceDate: zod
              .string()
              .nullable()
              .describe("최저가 거래 날짜"),
            supplierPrice: zod
              .number()
              .nullish()
              .describe("공급사별 단가 (supplierId 파라미터 제공 시에만 반환)"),
            supplierLastTransactionDate: zod
              .string()
              .nullish()
              .describe("공급사별 최근 거래 일자"),
            unit: zod.string().optional().describe("단위"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            supplierCount: zod
              .number()
              .optional()
              .describe(
                "이 품목을 취급하는 공급사 수 (활성 거래이력 기준, 탈퇴/정지 계정 제외). 모든 환경에서 반환된다.",
              ),
            autoQuoteSupplierCount: zod
              .number()
              .optional()
              .describe(
                "이 품목을 취급하는 공급사 중 자동견적(auto_quote_enabled)을 켠 공급사 수. supplierCount 의 부분집합이며, 자동견적을 켠 곳이 없으면 0. 집계 시점은 검색 색인 동기화 주기(매일 새벽)를 따른다.",
              ),
            canAutoQuote: zod
              .boolean()
              .optional()
              .describe(
                "자동 견적 가능 여부 (supplierCount > 0, 즉 취급 공급사가 1곳 이상인지). 자동견적을 켠 공급사가 있는지는 autoQuoteSupplierCount 로 판단할 것.",
              ),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 인기 품목 조회 (공급사 수 많은순, read-only)
 */
export const itemsV2ControllerGetPopularQueryParams = zod
  .object({
    limit: zod.coerce.string().optional(),
  })
  .strict();

export const itemsV2ControllerGetPopularResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            casNo: zod
              .string()
              .nullish()
              .describe(
                "CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)",
              ),
            keNo: zod
              .string()
              .nullish()
              .describe(
                "국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null",
              ),
            unNo: zod
              .string()
              .nullish()
              .describe("UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null"),
            enNo: zod.string().nullish().describe("EC 번호 (EU EINECS/ELINCS)"),
            chemNameKor: zod
              .string()
              .nullish()
              .describe("KOSHA 기준 국문 표준 물질명"),
            id: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
            name: zod.string().describe("상품명"),
            categoryId: zod
              .string()
              .nullable()
              .describe(
                "카테고리 ID (items_v2_categories.id - UUID, FK to normalized category table)",
              ),
            categoryPath: zod.string().describe("카테고리 경로 (표시용)"),
            price: zod.number().describe("기준 가격 (정가)"),
            lowestPrice: zod.number().nullable().describe("최저가 거래 단가"),
            lowestPriceDate: zod
              .string()
              .nullable()
              .describe("최저가 거래 날짜"),
            supplierPrice: zod
              .number()
              .nullish()
              .describe("공급사별 단가 (supplierId 파라미터 제공 시에만 반환)"),
            supplierLastTransactionDate: zod
              .string()
              .nullish()
              .describe("공급사별 최근 거래 일자"),
            unit: zod.string().optional().describe("단위"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            supplierCount: zod
              .number()
              .optional()
              .describe(
                "이 품목을 취급하는 공급사 수 (활성 거래이력 기준, 탈퇴/정지 계정 제외). 모든 환경에서 반환된다.",
              ),
            autoQuoteSupplierCount: zod
              .number()
              .optional()
              .describe(
                "이 품목을 취급하는 공급사 중 자동견적(auto_quote_enabled)을 켠 공급사 수. supplierCount 의 부분집합이며, 자동견적을 켠 곳이 없으면 0. 집계 시점은 검색 색인 동기화 주기(매일 새벽)를 따른다.",
              ),
            canAutoQuote: zod
              .boolean()
              .optional()
              .describe(
                "자동 견적 가능 여부 (supplierCount > 0, 즉 취급 공급사가 1곳 이상인지). 자동견적을 켠 공급사가 있는지는 autoQuoteSupplierCount 로 판단할 것.",
              ),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 
      공급사별 품목 단가 조회 (판매자 대시보드 견적 응답 시 자동 입력용)
      - 공급사의 최근 거래 단가 반환
      - 거래 이력이 없으면 null 반환
    
 * @summary 공급사별 품목 단가 조회
 */
export const itemsV2ControllerGetSupplierPriceQueryParams = zod
  .object({
    itemId: zod.coerce.string().describe("품목 ID (items_v2_base.id - UUID)"),
    supplierId: zod.coerce.string().describe("공급사 ID"),
  })
  .strict();

export const itemsV2ControllerGetSupplierPriceResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        itemId: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
        supplierId: zod.string().describe("공급사 ID"),
        supplierPrice: zod
          .number()
          .nullable()
          .describe("공급사별 단가 (최근 거래가)"),
        lastTransactionDate: zod
          .string()
          .nullable()
          .describe("공급사 최근 거래 일자"),
        hasHistory: zod.boolean().describe("거래 이력 존재 여부"),
        itemName: zod.string().nullable().describe("상품명 (참고용)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 
      특정 공급사가 과거에 거래한 모든 품목을 조회합니다.
      - 해당 공급사의 최근 거래 일자 순으로 정렬
      - 거래 이력이 있는 품목만 반환
      - 각 품목별 최근 거래 단가 포함
    
 * @summary 공급사별 거래 품목 조회
 */
export const itemsV2ControllerGetSupplierItemsParams = zod
  .object({
    supplierId: zod.coerce.string().describe("공급사 ID (업체id)"),
  })
  .strict();

export const itemsV2ControllerGetSupplierItemsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            itemId: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
            name: zod.string().describe("상품명"),
            categoryPath: zod.string().describe("카테고리 경로 (cat1 > cat2)"),
            lastTransactionDate: zod
              .string()
              .describe("최근 거래 일자 (해당 공급사 기준)"),
            lastUnitPrice: zod
              .number()
              .describe("최근 거래 단가 (해당 공급사 기준)"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 로그인 전에는 공급사명·ID 를 «공급사 A» 같은 표식으로 가린다.
 * @summary 품목별 공급사 가격 비교 (단가 낮은순, read-only)
 */
export const itemsV2ControllerGetItemSupplierComparisonParams = zod
  .object({
    id: zod.coerce.string().describe("품목 UUID"),
  })
  .strict();

export const itemsV2ControllerGetItemSupplierComparisonResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            supplierId: zod.string().describe("공급사 ID"),
            supplierName: zod.string().nullable().describe("공급사명"),
            unitPrice: zod.number().nullable().describe("거래 단가 (원)"),
            transactionDate: zod
              .string()
              .nullable()
              .describe("최근 거래일 (YYYYMMDD)"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * items_v2_base 테이블에서 UUID로 품목 상세 정보 조회
 * @summary 품목 상세 조회 (UUID)
 */
export const itemsV2ControllerFindByIdParams = zod
  .object({
    id: zod.coerce.string().describe("품목 UUID (items_v2_base.id)"),
  })
  .strict();

export const itemsV2ControllerFindByIdResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        casNo: zod
          .string()
          .nullish()
          .describe(
            "CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)",
          ),
        keNo: zod
          .string()
          .nullish()
          .describe(
            "국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null",
          ),
        unNo: zod
          .string()
          .nullish()
          .describe("UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null"),
        enNo: zod.string().nullish().describe("EC 번호 (EU EINECS/ELINCS)"),
        chemNameKor: zod
          .string()
          .nullish()
          .describe("KOSHA 기준 국문 표준 물질명"),
        id: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
        name: zod.string().describe("상품명"),
        categoryId: zod
          .string()
          .nullable()
          .describe(
            "카테고리 ID (items_v2_categories.id - UUID, FK to normalized category table)",
          ),
        categoryPath: zod.string().describe("카테고리 경로 (표시용)"),
        price: zod.number().describe("기준 가격 (정가)"),
        lowestPrice: zod.number().nullable().describe("최저가 거래 단가"),
        lowestPriceDate: zod.string().nullable().describe("최저가 거래 날짜"),
        supplierPrice: zod
          .number()
          .nullish()
          .describe("공급사별 단가 (supplierId 파라미터 제공 시에만 반환)"),
        supplierLastTransactionDate: zod
          .string()
          .nullish()
          .describe("공급사별 최근 거래 일자"),
        unit: zod.string().optional().describe("단위"),
        manufacturer: zod.string().optional().describe("제조사"),
        brand: zod.string().optional().describe("브랜드"),
        spec1: zod.string().optional().describe("규격 1"),
        spec2: zod.string().optional().describe("규격 2"),
        spec3: zod.string().optional().describe("규격 3"),
        supplierCount: zod
          .number()
          .optional()
          .describe(
            "이 품목을 취급하는 공급사 수 (활성 거래이력 기준, 탈퇴/정지 계정 제외). 모든 환경에서 반환된다.",
          ),
        autoQuoteSupplierCount: zod
          .number()
          .optional()
          .describe(
            "이 품목을 취급하는 공급사 중 자동견적(auto_quote_enabled)을 켠 공급사 수. supplierCount 의 부분집합이며, 자동견적을 켠 곳이 없으면 0. 집계 시점은 검색 색인 동기화 주기(매일 새벽)를 따른다.",
          ),
        canAutoQuote: zod
          .boolean()
          .optional()
          .describe(
            "자동 견적 가능 여부 (supplierCount > 0, 즉 취급 공급사가 1곳 이상인지). 자동견적을 켠 공급사가 있는지는 autoQuoteSupplierCount 로 판단할 것.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 해당 품목의 네이버 쇼핑 최저가·최고가·평균가를 반환합니다. 24시간 캐시 적용.
 * @summary 네이버 쇼핑 시세 조회
 */
export const itemsV2ControllerGetMarketPriceParams = zod
  .object({
    id: zod.coerce.string().describe("품목 UUID"),
  })
  .strict();
